import * as api from '@/service/server-api';

const detail = {
    state: {
        // 文章是否存在
        isExist: true,
        // 是否正在加载
        loading: false,
        normal: {}
    },
    mutations: {
        'detail:reset'(state) {
            state.isExist = true;
            state.loading = false;
            state.normal = {};
        },
        'detail:update'(state, payload) {
            for(let key in payload) {
                state[key] = payload[key];
            }
        }
    },
    actions: {
        async 'detail:init'({commit, dispatch}, id) {
            commit('detail:reset');
            if(!id) {
                commit('detail:update', {isExist: false, normal: {}});
            } else {
                // 获取详情数据
                dispatch('detail:query:normal', id);
            }
        },
        async 'detail:query:normal'({commit}, id) {
            commit('detail:update', {loading: true});
            const {code, data} = await api.getDetail({id}) || {};
            const payload = {loading: false};
            if(code === 0) {
                if(data) {
                    payload.normal = data;
                } else {
                    payload.isExist = false;
                }
            } else {
                payload.isExist = false;
            }
            commit('detail:update', payload);
        }
    },
    getters: {
        'detail:isExist'(state) {
            return state.isExist;
        },
        'detail:loading'(state) {
            return state.loading;
        },
        'detail:normal'(state) {
            return state.normal;
        }
    }
}

export default detail;



// WEBPACK FOOTER //
// ./src/store/modules/detail.js